<!-- KYMW0003 企画支援選択 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">企画支援選択</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <wj-flex-grid id="dtg_PlanSupportCompanyInfo" #dtg_PlanSupportCompanyInfo
          [itemsSource]="this.model.planSupportCompanyInfoList" [allowDragging]="'None'" [headersVisibility]="'Column'"
          [selectionMode]="'Row'" [style.width.px]="577" [style.height.px]="540" [isReadOnly]="true"
          [allowSorting]="false" [autoRowHeights]="true" [tabindex]="0">
          <wj-flex-grid-column [header]="'会社名'" [minWidth]="5" [width]="360" [binding]="'associatedCompanyName'"></wj-flex-grid-column>
          <wj-flex-grid-column [header]="'取引停止区分'" [minWidth]="5" [width]="200" [binding]="'tradeStopName'"
            [maxLength]="256"></wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button #btn_Setting class="btn-primary" (click)="eventClickHandler_Setting()" [tabindex]="0"
            forcedEnabledMode="true">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>